import React from 'react';
import PropTypes from 'prop-types';
import {Box, Typography} from "@material-ui/core";
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';

const MultiCityLegTitle = ({title, icon}) => {

    return (
        <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
            <Typography variant={'h6'}>
                {title}
            </Typography>
            {icon}
        </Box>
    );
};

MultiCityLegTitle.propTypes = {
    title: PropTypes.node,
    icon: PropTypes.node,
};

MultiCityLegTitle.defaultProps = {
    title: null,
    icon: <DragIndicatorIcon cursor={'grab'}/>,
};

export default MultiCityLegTitle;